import React, { useEffect, useRef, useState } from "react";
import { FaCheck } from "react-icons/fa";
import { Link } from "react-router-dom";

import { BiMouse } from "react-icons/bi";
import { FaRulerCombined } from "react-icons/fa";
import { MdOutlineAssignment } from "react-icons/md";

import { ClientSlider, HomeSlider } from "../Components/HomeSlider";
import AboutSection from "../Components/AboutSection";

function OurService() {
  const [activeTab, setActiveTab] = useState(1);

  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
  };

  return (
    <div className="container mb-20 mt-18  mx-auto md:px-6">
      <div className="md:mx-10 my-5">
        <h2 className="font-extrabold my-5	leading-snug	text-center py-5 text-4xl font-teko">
          OUR SERVICES
        </h2>
        <p className="text-center text-md">
          STRATUS INSTRUMENTATION PVT. LTD. and Test Labs LLP focuses on offering edge cutting
          smarter, innovative, and creative AI solutions to help you grow your
          business effectively and efficiently, serving you with better
          innovative ideas and strategies
        </p>
      </div>
      <div className="flex flex-wrap w-[100%]">
        <div className="p-2 w-[100%] md:w-[30%]">
          <nav
            className="flex flex-col space-y-4"
            aria-label="Tabs"
            role="tablist"
            data-hs-tabs-vertical="true"
          >
            <button
              type="button"
              className={`hs-tab-active:border-blue-500 ${
                activeTab === 1
                  ? "hs-tab-active:text-blue-600 bg-blue-900 text-white ng-red"
                  : "text-gray-500 hover:text-blue-600"
              } py-2 pr-4 px-2 text-lg font-semibold inline-flex bg-[#DCDCDC] text-black items-center font-teko gap-2 border-r-[3px] border-transparent whitespace-nowrap  active`}
              id="vertical-tab-with-border-item-1"
              data-hs-tab="#vertical-tab-with-border-1"
              aria-controls="vertical-tab-with-border-1"
              role="tab"
              onClick={() => handleTabClick(1)}
            >
              01. Custom Software Development
            </button>
            <button
              type="button"
              className={`hs-tab-active:border-blue-500 ${
                activeTab === 2
                  ? "hs-tab-active:text-blue-600 bg-blue-900 text-white"
                  : "text-gray-500 hover:text-blue-600"
              } py-2 pr-4 px-2 text-lg font-semibold inline-flex bg-[#DCDCDC] text-black items-center font-teko gap-2 border-r-[3px] border-transparent whitespace-nowrap 
               active`}
              id="vertical-tab-with-border-item-2"
              data-hs-tab="#vertical-tab-with-border-2"
              aria-controls="vertical-tab-with-border-2"
              role="tab"
              onClick={() => handleTabClick(2)}
            >
              02. Software Consulting
            </button>
            <button
              type="button"
              className={`hs-tab-active:border-blue-500 ${
                activeTab === 3
                  ? "hs-tab-active:text-blue-600 bg-blue-900 text-white"
                  : "text-gray-500 hover:text-blue-600"
              } py-2 pr-4 px-2 text-lg font-semibold inline-flex bg-[#DCDCDC] text-black items-center font-teko gap-2 border-r-[3px] border-transparent whitespace-nowrap active`}
              id="vertical-tab-with-border-item-3"
              data-hs-tab="#vertical-tab-with-border-3"
              aria-controls="vertical-tab-with-border-3"
              role="tab"
              onClick={() => handleTabClick(3)}
            >
              03. E-Commerce Solutions
            </button>
            <button
              type="button"
              className={`hs-tab-active:border-blue-500 ${
                activeTab === 4
                  ? "hs-tab-active:text-blue-600 bg-blue-900 text-white"
                  : "text-gray-500 hover:text-blue-600"
              } py-2 pr-4 px-2 text-lg font-semibold inline-flex bg-[#DCDCDC] text-black items-center font-teko gap-2 border-r-[3px] border-transparent whitespace-nowrap active`}
              id="vertical-tab-with-border-item-4"
              data-hs-tab="#vertical-tab-with-border-4"
              aria-controls="vertical-tab-with-border-4"
              role="tab"
              onClick={() => handleTabClick(4)}
            >
              04. Apps Development
            </button>
            <button
              type="button"
              className={`hs-tab-active:border-blue-500 ${
                activeTab === 5
                  ? "hs-tab-active:text-blue-600 bg-blue-900 text-white"
                  : "text-gray-500 hover:text-blue-600"
              } py-2 pr-4 px-2 text-lg font-semibold inline-flex bg-[#DCDCDC] text-black items-center font-teko gap-2 border-r-[3px] border-transparent whitespace-nowrap active`}
              id="vertical-tab-with-border-item-5"
              data-hs-tab="#vertical-tab-with-border-5"
              aria-controls="vertical-tab-with-border-5"
              role="tab"
              onClick={() => handleTabClick(5)}
            >
              05. Cyber Security
            </button>
          </nav>
        </div>

        <div className="p-2 w-[100%] md:w-[70%]">
          <div
            id="vertical-tab-with-border-2"
            className={activeTab === 1 ? "" : "hidden"}
            role="tabpanel"
            aria-labelledby="vertical-tab-with-border-item-2"
          >
            <div className="grid gap-6 lg:grid-cols-2 xl:gap-x-12">
              <div className="w-full">
                <img
                  src="./img/softwaredevelopment.jpg"
                  alt="softwaredevelopment.jpg"
                  className="h-full w-full"
                />
              </div>
              <div>
                <h3 className="text-3xl font-bold mb-5">
                  Custom Software Development
                </h3>
                <p className="text-justify">
                  Our specialised Customized Software Development is the process
                  of designing, building, deploying, and maintaining software
                  for all types of SME’s and MSME’s that is tailored to their
                  needs and aims to improve every industry to a new level.
                </p>
              </div>
            </div>
          </div>
          <div
            id="vertical-tab-with-border-2"
            className={activeTab === 2 ? "" : "hidden"}
            role="tabpanel"
            aria-labelledby="vertical-tab-with-border-item-2"
          >
            <div className="grid gap-6 lg:grid-cols-2 xl:gap-x-12">
              <div className="w-full">
                <img
                  src="./img/softwareconsulting.jpg"
                  alt="softwareconsulting.jpg"
                  className="h-full w-full"
                />
              </div>
              <div>
                <h3 className="text-3xl font-bold mb-5">
                  Software Consultancy
                </h3>
                <p className="text-justify">
                  STRATUS INSTRUMENTATION PVT. LTD. and Test Labs LLP diagnose, analyze,
                  identify, plan, and offer solutions that are compatible with
                  every organization's needs. Expertizing our knowledge and
                  experience at all instances accelerates.
                </p>
              </div>
            </div>
          </div>
          <div
            id="vertical-tab-with-border-3"
            className={activeTab === 3 ? "" : "hidden"}
            role="tabpanel"
            aria-labelledby="vertical-tab-with-border-item-3"
          >
            <div className="grid gap-6 lg:grid-cols-2 xl:gap-x-12">
              <div className="w-full">
                <img
                  src="./img/ecommerce.jpg"
                  alt="ecommerce.jpg"
                  className="h-full w-full"
                />
              </div>
              <div>
                <h3 className="text-3xl font-bold mb-5">
                  E-Commerce Solutions
                </h3>
                <p className="text-justify">
                  Our E-Commerce Software facilitates quicker and trusted growth
                  of income and profit for both, beginner's playground, and an
                  expert home field by meeting the demands of any small- to
                  medium-sized firm.
                </p>
              </div>
            </div>
          </div>
          <div
            id="vertical-tab-with-border-4"
            className={activeTab === 4 ? "" : "hidden"}
            role="tabpanel"
            aria-labelledby="vertical-tab-with-border-item-4"
          >
            <div className="grid gap-6 lg:grid-cols-2 xl:gap-x-12">
              <div className="w-full">
                <img
                  src="./img/apps.jpg"
                  alt="apps.jpg"
                  className="h-full w-full"
                />
              </div>
              <div>
                <h3 className="text-3xl font-bold mb-5">Apps Development</h3>
                <p className="text-justify">
                  Our Application Development assists you in creating beneficial
                  and efficient experiences on every device and help you get the
                  most out of mobile Technology for your business with our
                  Application Development Services, which draw on our team's
                  strong expertise in developing Customized Applications.
                </p>
              </div>
            </div>
          </div>
          <div
            id="vertical-tab-with-border-5"
            className={activeTab === 5 ? "" : "hidden"}
            role="tabpanel"
            aria-labelledby="vertical-tab-with-border-item-5"
          >
            <div className="grid gap-6 lg:grid-cols-2 xl:gap-x-12">
              <div className="w-full">
                <img
                  src="./img/cyber.jpg"
                  alt="cyber.jpg"
                  className="h-full w-full"
                />
              </div>
              <div>
                <h3 className="text-3xl font-bold mb-5">Cyber Security</h3>
                <p className="text-justify">
                  To guarantee that your systems and data are safe, Recon
                  Calibration and Test Labs LLP Cyber Security employs a
                  patented technique to execute a controlled external real-life
                  evaluation and penetration test of your firewalls, network
                  entry points, and public IP addresses.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const Home = () => {
  return (
    <div>
      <HomeSlider />
      
      {/* <ClientShowcase/> */}

      <AboutSection />

      <section class="py-16 bg-white">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 class="text-4xl font-bold text-gray-800 mb-4">
            Our <span class="text-orange-600">Values</span>
          </h2>
          <div class="flex justify-center items-center mb-12">
            <span class="w-8 h-1 bg-gray-300"></span>
            <span class="mx-2 text-orange-600 text-xl">◆</span>
            <span class="w-8 h-1 bg-gray-300"></span>
          </div>

          <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10 text-center">
            <div class="hover-scale">
              <img
                src="https://cdn-icons-png.flaticon.com/512/2991/2991146.png"
                alt="Integrity"
                class="mx-auto w-20 h-20 mb-4"
              />
              <h3 class="text-xl font-bold text-blue-700">Integrity</h3>
              <p class="text-gray-600 mt-2">
                Upholding the highest standards of honesty and ethical conduct.
              </p>
            </div>

            <div class="hover-scale">
              <img
                src="https://cdn-icons-png.flaticon.com/512/1013/1013925.png"
                alt="Innovation"
                class="mx-auto w-20 h-20 mb-4"
              />
              <h3 class="text-xl font-bold text-blue-700">Innovation</h3>
              <p class="text-gray-600 mt-2">
                Continuously improving through creative solutions and advanced
                technologies.
              </p>
            </div>

            <div class="hover-scale">
              <img
                src="https://cdn-icons-png.flaticon.com/512/2933/2933885.png"
                alt="Excellence"
                class="mx-auto w-20 h-20 mb-4"
              />
              <h3 class="text-xl font-bold text-blue-700">Excellence</h3>
              <p class="text-gray-600 mt-2">
                Delivering superior quality in every aspect of our work.
              </p>
            </div>

            <div class="hover-scale">
              <img
                src="https://cdn-icons-png.flaticon.com/512/2921/2921822.png"
                alt="Collaboration"
                class="mx-auto w-20 h-20 mb-4"
              />
              <h3 class="text-xl font-bold text-blue-700">Collaboration</h3>
              <p class="text-gray-600 mt-2">
                Fostering strong partnerships with clients and stakeholders.
              </p>
            </div>

            <div class="hover-scale">
              <img
                src="https://cdn-icons-png.flaticon.com/512/3062/3062634.png"
                alt="Sustainability"
                class="mx-auto w-20 h-20 mb-4"
              />
              <h3 class="text-xl font-bold text-blue-700">Sustainability</h3>
              <p class="text-gray-600 mt-2">
                Promoting environmentally responsible practices in all
                operations.
              </p>
            </div>

            <div className="flex items-center">
              <img
                src="./img/logo.png"
                alt="Logo"
                class="mx-auto w-40 opacity-90"
              />
            </div>
          </div>
        </div>
      </section>

      <StatsSection />

      {/* <section
        className="bg-cover max-w-full h-auto my-1"
        // style={{ backgroundImage: "url('./img/homeourprod.jpg')" }}
      > */}
      {/* <div className="text-center w-[60%] m-auto py-3  font-teko"> */}
      {/* <h5 className="text-2xl font-[500]">Our Products</h5> */}
      {/* <h6 className="text-4xl font-[800]">Our Accredition</h6>
          <p className="text-gray-700 max-w-3xl mx-auto my-3">
            ISO/IEC 17025 Accredited Calibration Laboratory by NABL vide
            Certificate Number CC-3885
          </p>
        </div>
      </section> */}

      {/* {OurService()} */}

      {/* {CalibrationSection()} */}
      {/* <ClientSlider /> */}

    </div>
  );
};

export default Home;

const CalibrationSection = () => {
  return (
    <section className="py-16 px-4 max-w-7xl mx-auto">
      <div className="text-center mb-12">
        <h2 className="text-3xl font-[800] mb-4">
          Why STRATUS INSTRUMENTATION PVT. LTD. and Test Labs LLP Calibration
        </h2>
        <p className="text-gray-700 max-w-3xl mx-auto">
          We are known as a STRATUS INSTRUMENTATION PVT. LTD. and Test Labs LLP service provider
          in Karnataka offering our customers superior quality highly efficient
          services.
        </p>
      </div>

      <div className="grid md:grid-cols-3 gap-8 mt-8">
        {/* Get Started Column */}
        <div className="text-center">
          <div className="flex justify-center mb-6">
            <BiMouse className="w-16 h-16" />
          </div>
          <h3 className="text-xl font-semibold mb-4 text-blue-600">
            Get Started
          </h3>
          <p className="text-gray-600">
            Established by ISO/IEC 17025: 2017 General Requirements for the
            Competence of Calibration and Testing Laboratories
          </p>
        </div>

        {/* Prepare Column */}
        <div className="text-center">
          <div className="flex justify-center mb-6">
            <FaRulerCombined className="w-16 h-16" />
          </div>
          <h3 className="text-xl font-semibold mb-4 text-blue-600">
            Prepare for your test
          </h3>
          <p className="text-gray-600">
            This includes equipment that is capable of calibrating to very fine
            resolutions-usually four to 10 times the resolution of the tools
            being calibrated
          </p>
        </div>

        {/* Results Column */}
        <div className="text-center">
          <div className="flex justify-center mb-6">
            <MdOutlineAssignment className="w-16 h-16" />
          </div>
          <h3 className="text-xl font-semibold mb-4 text-blue-600">
            Get Results
          </h3>
          <p className="text-gray-600">
            Laboratory quality can be defined as accuracy, reliability, and
            timeliness of the reported test results.
          </p>
        </div>
      </div>
    </section>
  );
};

const useCountUp = (end, duration, shouldStart) => {
  const [count, setCount] = useState(0);
  const frame = useRef();
  const startTime = useRef(null);

  useEffect(() => {
    if (!shouldStart) return;

    const step = (timestamp) => {
      if (!startTime.current) startTime.current = timestamp;
      const progress = timestamp - startTime.current;
      const percent = Math.min(progress / duration, 1);
      setCount(Math.floor(percent * end));
      if (percent < 1) {
        frame.current = requestAnimationFrame(step);
      }
    };

    frame.current = requestAnimationFrame(step);
    return () => cancelAnimationFrame(frame.current);
  }, [end, duration, shouldStart]);

  return count;
};

const Stat = ({ value, suffix, label }) => {
  const [visible, setVisible] = useState(false);
  const ref = useRef();
  const count = useCountUp(value, 1500, visible);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.5 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <div ref={ref} className="text-center p-4">
      <div className="text-4xl font-bold text-orange-600">
        {count}
        {suffix}
      </div>
      <div className="text-gray-700 font-semibold mt-2">{label}</div>
    </div>
  );
};

export const StatsSection = () => {
  const stats = [
    { value: 7, suffix: "+", label: "Years of Combined Expertise" },
    { value: 100, suffix: "+", label: "Projects Executed" },
    { value: 100, suffix: "+", label: "Clients Served" },
    { value: 75, suffix: "+", label: "Field & Lab Equipment Units" },
  ];

  return (
    <section className="bg-gray-100 py-12">
      <div class="max-w-6xl mx-auto text-center">
        <h2 class="text-4xl font-bold text-orange-600 mb-2">
          Statistics
        </h2>
        <div class="flex items-center justify-center mb-4">
          <span class="w-10 h-0.5 bg-gray-400"></span>
          <span class="mx-2 w-2 h-2 bg-blue-500 rounded-full"></span>
          <span class="w-10 h-0.5 bg-gray-400"></span>
        </div>
        <p class="text-gray-700 mb-16 text-sm md:text-base">
          Proven performance through measurable impact and consistent delivery
          across sectors.
        </p>
        <div className="container mx-auto px-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {stats.map((stat, idx) => (
            <Stat key={idx} {...stat} />
          ))}
        </div>
      </div>
    </section>
  );
};



const companies = [
  {
    front: "KAPSA Global",
    back: {
      logo: "https://via.placeholder.com/150x50?text=KAPSA",
      location: "Global HQ",
    },
    bg: "bg-orange-500",
  },
  {
    front: null,
    back: {
      logo: "https://via.placeholder.com/150x50?text=KAPSA+Testing",
      location: "Dubai, UAE",
    },
  },
  {
    front: null,
    back: {
      logo: "https://via.placeholder.com/150x50?text=KAPSA+Infra",
      location: "Mumbai, INDIA",
    },
  },
  {
    front: null,
    back: {
      logo: "https://via.placeholder.com/150x50?text=KAPSA+Marine",
      location: "Mumbai, INDIA",
    },
  },
];

const ClientShowcase = () => {
  return (
    <div>
      {/* Hero Section */}
      <div
        className="relative bg-cover bg-center text-white py-20 px-6"
        style={{
          backgroundImage: "url('./img/homebanner.jpg')",
        }}
      >
        <div className="absolute inset-0 bg-black bg-opacity-60"></div>
        <div className="relative z-10 text-center max-w-4xl mx-auto">
          <p className="text-sm font-semibold text-orange-400 mb-3">
            # Building Tomorrow's World Today
          </p>
          <h1 className="text-4xl md:text-5xl font-bold mb-4">
            Engineering Excellence Across Land and Sea
          </h1>
          <p className="text-md md:text-lg text-gray-200 mb-6">
            Delivering integrated geotechnical, infrastructure, and marine solutions through our global expertise.
          </p>
          <div className="flex justify-center gap-4 flex-wrap">
            {/* <button className="bg-orange-500 hover:bg-orange-600 text-white px-6 py-3 rounded-full text-sm font-semibold">
              OUR COMPANIES ↓
            </button> */}
            <button className="border border-white hover:bg-white hover:text-black transition text-white px-6 py-3 rounded-full text-sm font-semibold">
              <Link to="/contact">
              CONTACT US →
              </Link>
            </button>
          </div>
        </div>
      </div>

      {/* Cards Section */}
      {/* <div className="bg-gray-100 py-12 px-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 max-w-7xl mx-auto">
          {companies.map((company, index) => (
            <FlipCard key={index} company={company} />
          ))}
        </div>
      </div> */}
    </div>
  );
};

const FlipCard = ({ company }) => {
  const [flipped, setFlipped] = useState(false);

  return (
    <div
      className="relative w-full h-48 perspective"
      onMouseEnter={() => setFlipped(true)}
      onMouseLeave={() => setFlipped(false)}
    >
      <div className={`w-full h-full transition-transform duration-700 transform-style preserve-3d relative ${flipped ? "rotate-y-180" : ""}`}>
        {/* Front Side */}
        <div
          className={`absolute inset-0 rounded-xl flex items-center justify-center text-white text-lg font-semibold backface-hidden ${
            company.bg || "bg-white text-gray-900"
          }`}
        >
          {company.front || (
            <img src={company.back.logo} alt="logo" className="h-12" />
          )}
        </div>

        {/* Back Side */}
        <div className="absolute inset-0 bg-white rounded-xl flex flex-col items-center justify-center text-center p-4 shadow-md rotate-y-180 backface-hidden">
          <img src={company.back.logo} alt="logo" className="h-12 mb-2" />
          <p className="font-medium text-gray-700">
            <strong>Location:</strong> <br />
            {company.back.location}
          </p>
        </div>
      </div>
    </div>
  );
};


